import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Relative, getPaletteColor } from 'pcln-design-system'
import styled from 'styled-components'
import airTheme from '../AirThemeProvider/airTheme'
import InfoArea from './InfoArea'
import PriceGuidanceChart from './PriceGuidanceChart'
import PriceGuidanceDescription from './PriceGuidanceDescription'

const PriceGuidanceWrapper = styled(Relative)`
  border: 1px solid ${getPaletteColor('border.base')};
`

const ChartWrapper = styled(Box)`
  ${airTheme.flyQueries.desktop} {
    width: 300px;
    margin-left: auto;
    margin-right: 30px;
  }
  ${airTheme.flyQueries.desktoplg} {
    margin-right: 50px;
  }
`

const DescriptionWrapper = styled(Flex)`
  ${airTheme.flyQueries.desktop} {
    position: absolute;
    top: 30px;
    left: 20px;
    margin-right: 390px;
    height: 40px;
    align-items: center;
  }
`

const PriceGuidanceInlineBox = ({ highPrice, lowPrice, actualPrice }) => (
  <PriceGuidanceWrapper p='20px' pb='0px' borderRadius='xl'>
    <Flex>
      <Box ml='auto'>
        <InfoArea />
      </Box>
    </Flex>
    <Flex>
      <ChartWrapper mt='-40px' mr='10px' width={1}>
        <PriceGuidanceChart highPrice={highPrice} lowPrice={lowPrice} actualPrice={actualPrice} />
      </ChartWrapper>
    </Flex>
    <DescriptionWrapper mb={3}>
      <PriceGuidanceDescription lowPrice={lowPrice} actualPrice={actualPrice} />
    </DescriptionWrapper>
  </PriceGuidanceWrapper>
)

PriceGuidanceInlineBox.propTypes = {
  highPrice: PropTypes.string.isRequired,
  lowPrice: PropTypes.string.isRequired,
  actualPrice: PropTypes.string.isRequired,
}

export default PriceGuidanceInlineBox
